function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M58.952 46.923c-1.042 0-1.737.692-1.737 1.712v8.547H12.781v-8.547c0-1.02-.671-1.712-1.712-1.712-1.019 0-1.714.692-1.714 1.712v10.241c0 1.042.695 1.713 1.714 1.713h47.883c.996 0 1.692-.671 1.692-1.713V48.635c.001-1.02-.696-1.712-1.692-1.712z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.946 26.071l14.337-11.627v34.191c0 1.019.692 1.715 1.714 1.715 1.043 0 1.736-.696 1.736-1.715V14.444l14.318 11.627c.349.348.696.348 1.042.348.349 0 1.042-.348 1.389-.695.651-.671.306-1.69-.347-2.386L36.04 9.669c-.695-.345-1.391-.345-2.064 0l-17.09 13.668c-.672.696-1.021 1.715-.35 2.386.695.696 1.715 1.043 2.41.348z"
}));

var SvgShare = function SvgShare(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 70 70",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShare, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/share.5b3504ad.svg";
export { ForwardRef as ReactComponent };